import { useState } from 'react'
import { COLORS } from 'app-constants'
import { CircularProgress, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import CompanyItem from './CompanyItem'
import SearchIcon from '@mui/icons-material/Search'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import { myTwinAtom } from 'state/my-twin'
import { useRecoilValue } from 'recoil'
import { useFetchCompanies } from 'hooks/use-trends'

const CompanyList = () => {
  const isMobile = useCheckMobileScreen()

  const myTwin = useRecoilValue(myTwinAtom)

  const { companies, isLoading } = useFetchCompanies(myTwin?.id || '')

  const [searchText, setSearchText] = useState('')
  const onSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value)
  }

  const filteredCompanies = companies.filter((company) => company.name.toLowerCase().includes(searchText.toLowerCase()))

  if (isLoading) {
    return <CircularProgress size="24px" thickness={4} style={{ color: COLORS.JELLED_PRIMARY_BLUE }} />
  }

  return (
    <Stack spacing={2}>
      <TextField
        placeholder="Search for a company"
        value={searchText}
        onChange={onSearchTextChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  color: COLORS.GRAY_3,
                  marginRight: '-10px',
                }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          width: isMobile ? '100%' : '400px',
          marginRight: isMobile ? '0' : '24px',
          input: {
            color: 'secondary.main',
          },
          '& ::placeholder': {
            color: 'secondary.main',
          },
        }}
      />
      {filteredCompanies.length > 0 ? (
        filteredCompanies.map((company) => <CompanyItem key={company.name} company={company} />)
      ) : (
        <Typography
          variant="pS"
          sx={{
            height: '100%',
            color: COLORS.GRAY_3,
          }}>
          We're generating trends for you. Please check back later.
        </Typography>
      )}
    </Stack>
  )
}

export default CompanyList
